import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { BrowserRouter, Switch } from "react-router-dom";
import reportWebVitals from './reportWebVitals';
import App from "./App";

ReactDOM.render(
  
  <BrowserRouter>
  <Switch>
    <App />
  </Switch>
</BrowserRouter>,
  
  document.getElementById('root')
);


reportWebVitals();
